import React, { Component } from 'react';
import buttons from '../css/module/buttons.css';
import ColumnsDropdown from './ColumnsDropdown';

const SQL = 'sql';

class SelectDashboardFilterColumn extends Component {
  render() {
    const { types, selectedCol, columns, onClick, aliases, onRemove } =
      this.props;

    const relevantColumns = columns.filter((c) =>
      types.includes(c.type().type()),
    );

    const tableName = !selectedCol
      ? null
      : selectedCol.hasAlias()
      ? selectedCol.alias() === SQL
        ? 'sql'
        : aliases[selectedCol.alias()]?.name() ?? 'custom-column'
      : 'custom-column';

    return !selectedCol ? (
      relevantColumns.length === 0 ? (
        <span>no relevant columns</span>
      ) : (
        <ColumnsDropdown
          onClick={onClick}
          columns={relevantColumns}
          aliases={aliases}
        >
          <button className={buttons.btn}>
            Select a column
            <span className="caret" />
          </button>
        </ColumnsDropdown>
      )
    ) : (
      <button onClick={onRemove} className={buttons.btn}>
        <span>{tableName}.</span>
        <span>
          <b>{selectedCol.name()}</b>
        </span>
        <span className={buttons.closePill}>×</span>
      </button>
    );
  }
}

export default SelectDashboardFilterColumn;
